import Comp from '../../../../../../ManagementApp/wwwroot/client/src/views/components/ProjectIntegrationStatusBadge.vue';
export default Comp;
